import { useQuery } from "react-query";
import Select from "react-select"

import { getCompanies } from "../../../../../MyApi/hr/companies";

import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addEmpolyment.module.css";
import { t } from "i18next";

const EditEmpolymentType = ({
  setLevelName,
  setCompanyId,
  companyId,
  selectedOption,
  setSelectedOption,
  levelName,
  setDescription,
  description,
  setActive,
  active,
}) => {
  const { data, isLoading } = useQuery("getComapines", getCompanies);

  const DollarSign = icons.Dollar;
  const Company = icons.company;
  const Ab = icons.abc;
  const handleNameChange = (e) => {
    setLevelName(e.target.value);
  };
  const handleSelectedIdChange = (selectedCompany) => {
    const companyId = selectedCompany ?selectedCompany.id :0
    setCompanyId(companyId);
   
  };
  const handleDescChange = (e) => {
    setDescription(e.target.value);
  };
  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setActive(1);
    } else {
      setActive(0);
    }
  };
  if (isLoading) {
    return <LoadingSpinner />;
  }
  const comapines = data?.data || [];
  const defaultCompanies = comapines.find((option=>option.id ===companyId))
  return (
    <div className={classes.formCard}>
      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">{t("Name")} </label>
          <div className={classes.iconInput}>
            <Ab />
          </div>
          <input
            type="text"
            placeholder="ادخل اسم "
            onChange={handleNameChange}
            value={levelName}
            className={classes.inputCustom}
          />
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">{t("Description")} </label>
          <div className={classes.iconInput}>
            <Ab />
          </div>
          <input
            type="text"
            placeholder="ادخل  الوصف"
            onChange={handleDescChange}
            value={description}
            className={classes.inputCustom}
          />
        </div>

        {!data ? (
          <div>no data available </div>
        ) : (
          <div className={classes.formCol}>
            <label htmlFor=""> {t("Company")}</label>
            <Select
              type="text"
              value={defaultCompanies}
              getOptionValue={(e)=>e.id}
              getOptionLabel={(e)=>e.name}
              options={comapines}
              placeholder="اختار الشركة  "
              onChange={handleSelectedIdChange}
              />
              
          </div>
        )}

        <div className={classes.formCol}>
          <label
            htmlFor=""
            className={active ? `${classes.active}` : `${classes.disActive}`}>
            {" "}
            {active == 1 ? " نشط" : "غير نشط"}{" "}
          </label>

          <label class="switch">
            <input
              type="checkbox"
              onChange={handleActiveChange}
              checked={active}
            />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default EditEmpolymentType;
